<!-- 企业匹配 -->
<template>
  <div v-show="certificationFlag == '1'">  
    <result ref="result"></result>
   </div>
   <div v-show="certificationFlag == '0'">
       <purchase ref="purchase"></purchase>
   </div> 

</template>
<script>
import { queryUserById } from '@/api/home'

import { clickUrl, clickUrlToPhone } from '@/utils'
import result from '@/views/searchMatching/result'
import purchase from '@/views/purchase/index'
import moment from 'moment'
import store from '@/store'

export default {
  name: 'EnterpriseMatch',
  components: { result,purchase },
  data() {
    return {
      certificationFlag: '',
    }
  },
  mounted() {
    this.getUserInfo()
  },
  methods: {
    async getUserInfo() {
      try {
        let res = await queryUserById()
          this.userInfo = res.result || {}
        let e_time = res.result.expiration_time ? res.result.expiration_time.replace(/-/g, '/') : null
        let expirationTime = new Date(e_time).getTime()
        let time = new Date().getTime()
        this.isVip = time < expirationTime ? 1 : 0
        this.userInfo.expiration_time_show = moment(res.result.expiration_time).format("YYYY年MM月DD日")
        this.certificationFlag = res.result.certification_flag
          
        if (this.certificationFlag) {
          let queryParams = {
            company_name: res.result.company.name,
            name: res.result.company.name
          } || {}
              this.$refs.result.queryParams = this.$route.query.search ? JSON.parse(this.$route.query.search) : queryParams
              this.$refs.result.userId = res.result.id
              this.$refs.result.isVip = this.isVip
              this.$refs.result.userInfo = this.userInfo
              this.$refs.result.init()
          }
          else {
            this.$refs.purchase.source = 'match'
            this.$refs.purchase.getUserInfo()
          }
      } catch { }
    },
    
  },
}
</script>
<style lang="scss" scoped>

</style>
